import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://admin.local.dev:8080'}/api`;

class MessagingService {
  async listConversations(archived = false) {
    const response = await axios.get(`${API_URL}/platform/messaging/conversations`, {
      params: archived ? { archived: 1 } : {},
    });
    return response.data.data || [];
  }

  async getConversation(id) {
    const response = await axios.get(`${API_URL}/platform/messaging/conversations/${id}`);
    return response.data.data;
  }

  async sendReply(id, body) {
    const response = await axios.post(`${API_URL}/platform/messaging/conversations/${id}`, { body });
    return response.data;
  }

  async listReports() {
    const response = await axios.get(`${API_URL}/platform/messaging/reports`);
    return response.data.data || [];
  }

  async hideMessage(messageId, reportId) {
    const response = await axios.post(`${API_URL}/platform/messaging/hide`, {
      messageId,
      reportId,
    });
    return response.data;
  }

  async sendCampaign(audience, body, userAccountId = null, shopId = null) {
    const payload = { audience, body };
    if (userAccountId) {
      payload.userAccountId = userAccountId;
    }
    if (shopId) {
      payload.shopId = shopId;
    }
    const response = await axios.post(`${API_URL}/platform/messaging/campaigns`, payload);
    return response.data.data;
  }
}

const messagingService = new MessagingService();
export default messagingService;
